import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Button, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import { FaBars, FaBoxOpen, FaList, FaSignOutAlt } from 'react-icons/fa'; // Import the necessary icons
import { useNavigate } from 'react-router-dom';
import logo from './assets/images/Logo.jpg'; // Replace with your logo if needed

const Sidebar = () => {
    const [showOffcanvas, setShowOffcanvas] = React.useState(false);
    const navigate = useNavigate();

    const handleToggle = () => setShowOffcanvas(!showOffcanvas);
    const handleClose = () => setShowOffcanvas(false);

    const handleLogout = () => {
        // You can clear sessionStorage/localStorage or handle logout logic here
        navigate('/login');  // Redirect to login page after logout
    };

    // Inline CSS to hide the navbar-toggler when the navbar is expanded
    const navbarTogglerStyle = {
        display: showOffcanvas ? 'none' : 'block', // Hide button when offcanvas is visible
    };

    // Inline style to set the Offcanvas width
    const offcanvasStyle = {
        width: '250px', // Set Offcanvas width to 250px
    };

    return (
        <div>
            {/* Navbar with black background */}
            <Navbar bg="dark" variant="dark" fixed="top">
                <div className="container-fluid">
                    <Button
                        className="navbar-toggler"
                        type="button"
                        onClick={handleToggle}
                        aria-controls="offcanvasNavbar"
                        aria-expanded={showOffcanvas}
                        style={navbarTogglerStyle} // Apply the inline style
                    >
                        <FaBars /> {/* Menu icon inside the button */}
                    </Button>
                    {/* Display logo instead of text */}
                    <Navbar.Brand href="#">
                        <img src={logo} alt="Logo" style={{ height: '40px' }} /> {/* Adjust height if needed */}
                    </Navbar.Brand>
                </div>
            </Navbar>

            {/* Offcanvas Sidebar with black background and custom width */}
            <Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                placement="start"
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                className="bg-dark text-white"
                style={offcanvasStyle} // Apply the custom width here
            >

                <img src={logo} alt="Logo" style={{ height: 'auto', width: 'auto' }} id="offcanvasNavbarLabel" />

                <Offcanvas.Body>
                    <Nav className="navbar-nav justify-content-end flex-grow-1 pe-3">
                        <Nav.Item>
                            <Nav.Link href="/category-list" className="text-white">
                                <FaList className="me-2" /> Category List {/* Category icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/subcategory-list" className="text-white">
                                <FaList className="me-2" /> Sub-category List {/* Sub-category icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/product-list" className="text-white">
                                <FaBoxOpen className="me-2" /> Product List {/* Product icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/Packages-list" className="text-white">
                                <FaList className="me-2" /> Packages List {/* Packages icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/Notes-list" className="text-white">
                                <FaList className="me-2" /> Notes List {/* Notes icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/Video-list" className="text-white">
                                <FaList className="me-2" /> Video List {/* Notes icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link href="/Album-list" className="text-white">
                                <FaList className="me-2" /> Album List {/* Notes icon */}
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link onClick={handleLogout} className="text-white">
                                <FaSignOutAlt className="me-2" /> Logout {/* Logout icon */}
                            </Nav.Link>
                        </Nav.Item>

                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};

export default Sidebar;
